<template>
    <div class="lite_select_view" v-if="data && data.did">
        <div class="lite_select_view_box">
            <div :class="'drive-icon drive-icon-' + getDrive(data.did).type"></div>
            <div class="lite_select_view_path">{{ getDrive(data.did).name + getNodePath(data.node) }}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: { type: Object, default: null },
    },
    methods: {
        // 获取云盘
        getDrive(id) {
            for (let i = 0; i < this.$store.state.drives.length; i++) {
                let drive = this.$store.state.drives[i];
                if (drive.id === id) {
                    return drive;
                }
            }
            return null;
        },
        // 获取节点路径
        getNodePath(node) {
            let path = '';
            let arr = this.getNodeArr(node);
            for (let i = 0; i < arr.length; i++) {
                let item = arr[i];
                path += '/' + item.name;
            }
            return path;
        },
        // 获取节点和父
        getNodeArr(node) {
            let arr = [];
            while (node) {
                arr.push(node);
                node = node.parent;
            }
            return arr.reverse();
        },
    },
};
</script>

<style scoped>
/* 布局 */
.lite_select_view {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0;
    background-color: #FFF;
}

/* 选择的云盘数据展示 */
.lite_select_view_box {
    width: 100%;
    height: 160px;
    padding: 10px;
    box-sizing: border-box;
    position: absolute;
    z-index: 2;
    margin: auto;
    top: 0;
    bottom: 0;
}

/* 云盘图标 */
.drive-icon {
    width: 75px;
    height: 75px;
    display: inline-block;
    margin-bottom: 50px;
    background-repeat: no-repeat;
    background-size: cover;
}

/* 云盘路径 */
.lite_select_view_path {
    font-size: 16px;
    color: rgba(88, 88, 88, 0.6);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>


// WEBPACK FOOTER //
// src/components/workspace/lite_select_view.vue